import { render, staticRenderFns } from "./RiderMediaIndex.vue?vue&type=template&id=4aec350f&lang=pug"
import script from "./RiderMediaIndex.vue?vue&type=script&lang=js"
export * from "./RiderMediaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports